import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectUserState } from '../../store/user';
import { Loader } from '../spinner';
import { ErrorScreen } from '../permissions';

function PrivateElement({ component: Element, permissions, role, ...props }) {
  const location = useLocation();

  const { loading, data } = useSelector(selectUserState);

  if (loading) return <Loader />;

  if (!data)
    return (
      <Redirect
        to={{
          pathname: '/auth',
          state: { referrer: location },
        }}
      />
    );

  if (role && data?.role !== role) {
    return <ErrorScreen />;
  }

  if (
    permissions &&
    !data?.permissions?.includes('all') &&
    permissions?.some(permission => !data?.permissions?.includes(permission))
  ) {
    return <ErrorScreen />;
  }

  return <Element {...props} />;
}

PrivateElement.propTypes = {
  component: PropTypes.any,
  permissions: PropTypes.array,
  role: PropTypes.string,
};

export function PrivateRoute({ component, permissions, role, ...rest }) {
  return (
    <Route
      {...rest}
      render={props => <PrivateElement component={component} permissions={permissions} role={role} {...props} />}
    />
  );
}

PrivateRoute.propTypes = {
  component: PropTypes.any,
  permissions: PropTypes.array,
  role: PropTypes.string,
};
